<template>
    <div class="Input InputAutocomplete">
        <el-autocomplete
            :name="'input-' + name"
            v-model="localModel"
            :fetch-suggestions="querySearch"
            :placeholder="placeholder"
            :class="{ error: localErrors.length }"
            v-on:blur="onBlur()"
            @select="handleSelect"
        >
        </el-autocomplete>
        <div v-if="errors" class="Input__error">{{localErrors[0]}}</div>
    </div>
</template>

<style lang="sass">
    @import ../../../common/styles/mixins
    @import ../../../common/styles/settings

    .InputAutocomplete
        position: relative
        .el-autocomplete
            width: 100%

            //&.error
                .el-input__inner
                    border-bottom: 1px solid $color-base

            .el-input__inner
                background: none
                border: 0
                border-bottom: 1px solid $color-text
                border-radius: 0
                padding: 0 0 1rem
                font-family: Roboto, sans-serif
                font-size: 1rem
                font-weight: 300

            input.el-input__inner::placeholder
                color: $color-text


    .el-autocomplete-suggestion__wrap
        border-radius: 0
        background-color: $color-gray-light

    .el-autocomplete-suggestion li:hover
        background-color: transparent
        color: $color-base

    .el-scrollbar__view li
        margin-top: 0.25rem
        margin-bottom: 0.25rem
        border-bottom: 1px solid rgba(0,0,0,0.15)
        padding-bottom: 0.5rem
        padding-top: 0.25rem
        &:last-child
            border-bottom: 0
            margin-bottom: 0
            padding-bottom: 0.5rem

</style>

<script>
    import { each } from "lodash/core";

    export default {
        props: ["name", "value", "items", "placeholder", "errors"],
        data() {
            return {
                localModel: this.value,
                localErrors: this.errors || [],
                localItems: null
            }
        },
        watch: {
            value: function(newVal, oldVal) {
                this.localModel = newVal;
            },
            errors: function(newVal, oldVal) {
                this.localErrors = newVal || [];
            }
        },
        methods: {
            querySearch(queryString, cb) {
                var results = queryString ? this.localItems.filter(this.createFilter(queryString)) : this.localItems;
                cb(results);
            },
            createFilter(queryString) {
                return (item) => {
                    return (item.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            handleSelect(item) {
                this.$emit("input", this.localModel);
            },
            onBlur: function() {
                this.$parent.validate();
            }
        },
        mounted() {
            this.localItems = [];
            each(this.items, (item, value)  => {
                this.localItems.push({ value: value });
            });
        }
    }

</script>
